import * as React from "react";

import "./infoDisplay.scss";

interface Props {
    title: string;
    percentageValue: number;
    value: number;
    total: number;
}

export const BubbleInfoDisplay: React.FC<Props> = (props) => {
    return (
        <div
            className={"info"}
        >
            <div className={"info-title"}>
                {props.title}
            </div>
            <div className={"info-percentage"}>
                {props.percentageValue.toFixed(2)}%
            </div>
            <div className={"info-value"}>
                {props.value} / {props.total}
            </div>
        </div>
    );
};
